import commonRes from '../abstract.resource';
import {readMinimalPerson, readPerson} from '../serializers/person.serializer';

const mod = angular.module('app.common.resources.person', [commonRes])

.factory('PersonResource', function ($q, AbstractResource) {
  class PersonResource extends AbstractResource {
    constructor() {
      super('personnel', PersonResource.fromBackend, true);
    }

    /**
     * Get personnel filtered by location
     * @param {Location} location Location id to filter by
     * @param {Boolean} minimal Should only minimal representation fetched?
     * @returns {Promise.<Array.<Person>>} Promise that is resolved with the list of acquired personnel.
     */
    filterPersonnelByLocation(location, minimal=false) {
      return this._filter('location', location.id, minimal);
    }

    /**
     * Get personnel filtered by service
     * @param {Service} service Service id to filter by
     * @param {Boolean} minimal Should only minimal representation fetched?
     * @returns {Promise.<Array.<Person>>} Promise that is resolved with the list of acquired personnel.
     */
    filterPersonnelByService(service, minimal=false) {
      return this._filter('service', service.id, minimal);
    }

    // Filter personnel by given key ('service' or 'location') and id
    _filter(key, id, minimal) {
      return this.getMany({minimal, [key]: id});
    }

    /**
     * Parse a person retrieved from the backend.
     * @param {Object} o
     * @param {Object} params
     * @returns {Person}
     */
    static fromBackend(o, params) {
      if ('minimal' in params && params.minimal === true) {
        return readMinimalPerson(o).makeImmutable();
      }
      else {
        return readPerson(o).makeImmutable();
      }
    }
  }

  return new PersonResource();
});

export default mod.name;
